<script setup lang="ts">
const { t } = useI18n()

const open = defineModel<boolean>('open', { default: false })

withDefaults(
  defineProps<{ item?: string; primaryActionPromise?: () => boolean | Promise<boolean> }>(),
  {
    item: '',
    primaryActionPromise: () => true,
  },
)

const itemToDelete = ref('')

const openModal = (item?: string) => {
  if (item) itemToDelete.value = item
  open.value = true
}

const closeModal = () => {
  open.value = false
  return true
}
</script>

<template>
  <div>
    <OModal
      v-model:open="open"
      :secondary-action-title="t('cancel')"
      :primary-action-title="t('delete_permanently')"
      primary-action-enabled
      secondary-action-enabled
      :secondary-action-promise="closeModal"
      :primary-action-promise="primaryActionPromise"
      danger
      :title="t('confirm_delete_user')"
    >
      <template #content>
        <i18n-t keypath="delete_user_subtitle" tag="span" class="typography-body-2 text-neutral-1">
          <span class="typography-body-2-strong">{{ item }}</span>
        </i18n-t>
      </template>
    </OModal>

    <slot :handle-click="openModal" />
  </div>
</template>
